/**
 * @voltxampere/ui — 5W power resistor variant (Sprint 38-4)
 *
 * Reference: yaygın 5 W wirewound silindir direnç (LED limit, dummy
 * load, current sense). Default R = 100 Ω, kullanıcı override eder.
 *
 *   resistance  = 100 Ω      (kullanıcı override)
 *   powerRating = 5 W        (Sprint 23 resistor schema additive)
 *
 * Sprint 38-5 R_thermal table'a `resistor / 5w-wirewound` entry
 * eklenir (R_th = 14 °C/W, T_max = 250 °C).
 *
 * Engine zero-diff invariant honored — variant maps to canonical
 * `resistor` engine stamp (Sprint 4); powerRating field thermal
 * model + ZENIT brand UI hint için, engine stamp ignore eder.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { resistor } from "../resistor.js";
export const resistor5w = {
    id: "resistor-5w",
    nameTr: "Direnç 5W (wirewound)",
    nameEn: "Resistor 5W (wirewound)",
    shortcut: "R",
    category: "passive",
    viewBox: resistor.viewBox,
    terminals: resistor.terminals,
    defaultLabel: "R",
    defaultValue: "100Ω 5W",
    schemaType: "resistor",
    defaultParams: { resistance: 100, powerRating: 5 },
    renderSVG: () => resistor.renderSVG(),
};
//# sourceMappingURL=resistor-5w.js.map